import './Style/Home.css';
import Blob from './components/Blob';
import Blur from './components/Blur';
import Blur2 from "./components/Blur2";
import Title from "./components/Title";
function Home() {
    return (
        <div className="parent">
            <section className="section">
            <div className="bg">
                <Blob color="red" />
                <Blob color="blue" />
                <Blob color="purple" />
                <Blob color="red" />
                <Blob color="blue" />
                <Blob color="purple" />
                <Blob color="red" />
                <Blob color="blue" />
                <Blob color="purple" />
                <Blob color="red" />
                <Blob color="blue" />
                <Blob color="purple" />
                <Blob color="red" />
                <Blob color="blue" />
                <Blob color="purple" />
                <Blob color="red" />
                <Blob color="blue" />
                <Blob color="purple" />
            </div>
            <Blur />
            <Blur2 />
            <Title />
            </section>
            </div>
    );
}

export default Home;
